/* Legacy `/legal/credit-disclosure` route — fully superseded by the new
 * Verqo Trade Score Methodology page (Iter 160 · 9-layer legal/compliance
 * migration). We keep this path mounted to avoid breaking links that
 * went out in old emails / shared with prospects, and redirect on mount. */
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

export default function CreditDisclosure() {
  // Keep the redirect declarative so it works even with JS bots that
  // pre-render the page (useEffect would be skipped server-side).
  useEffect(() => { /* no-op — Navigate handles the swap below */ }, []);
  return <Navigate to="/legal/trade-score" replace />;
}
